import { httpClient } from "../../network/httpclient/HttpClientFactory";

const BASE = "/rtk";

const getRealtimeAll = () =>
  httpClient.get(`${BASE}/realtime`).then((res) => res.data);

const getRealtimeByDevice = (deviceId) =>
  httpClient.get(`${BASE}/realtime/${deviceId}`).then((res) => res.data);

const getEquipmentRunSummary = () =>
  httpClient
    .get(`${BASE}/statistics/equipment-run-summary`)
    .then((res) => res.data);

const getStatisticsSummary = (params) =>
  httpClient
    .get(`${BASE}/statistics/summary`, { params })
    .then((res) => res.data);

const getStatisticsSummaryByDevice = (deviceId, params) =>
  httpClient
    .get(`${BASE}/statistics/summary/${deviceId}`, { params })
    .then((res) => res.data);

const getStatisticsDaily = (params) =>
  httpClient
    .get(`${BASE}/statistics/daily`, { params })
    .then((res) => res.data);

const getStatisticsDailyByDevice = (deviceId, params) =>
  httpClient
    .get(`${BASE}/statistics/daily/${deviceId}`, { params })
    .then((res) => res.data);

const getStatisticsUtilization = (params) =>
  httpClient
    .get(`${BASE}/statistics/utilization`, { params })
    .then((res) => res.data);

const getStatisticsHourlyPattern = (deviceId, params) =>
  httpClient
    .get(`${BASE}/statistics/hourly-pattern/${deviceId}`, { params })
    .then((res) => res.data);

const getStayLocations = (deviceId, params) =>
  httpClient
    .get(`${BASE}/statistics/stay-locations/${deviceId}`, { params })
    .then((res) => res.data);

const getHistoryByDevice = (deviceId, startDate, endDate) =>
  httpClient
    .get(`${BASE}/history/${deviceId}`, { params: { startDate, endDate } })
    .then((res) => res.data);

export default {
  getRealtimeAll,
  getRealtimeByDevice,
  getEquipmentRunSummary,
  getStatisticsSummary,
  getStatisticsSummaryByDevice,
  getStatisticsDaily,
  getStatisticsDailyByDevice,
  getStatisticsUtilization,
  getStatisticsHourlyPattern,
  getStayLocations,
  getHistoryByDevice,
};
